// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .botResponseAttachments {
  color: var(--sdk-chat-window-bot-bubble-font-clr);
  padding: 2px 5px;
  width: 100%;
  margin: 2px 0;
}

.kore-chat-window .botResponseAttachments .uploadedFileIcon {
  float: left;
  width: 100%;
  margin-top: 3px;
  border-bottom: 2px solid #F1F0F0;
}

.kore-chat-window .botuploadedFileName {
  float: left;
  width: 100%;
  text-align: center;
  min-width: 80px;
  font-size: 14px;
  padding: 3px 0px 3px 0px;
}

.kore-chat-window .uploadedFileName {
  border-top: 1px solid var(--sdk-chat-widow-primary-border-color);
  color: var(--sdk-chat-window-bot-bubble-font-clr);
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/templateAttachment/templateAttachment.scss"],"names":[],"mappings":"AAAA;EACI,iDAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;AACJ;;AAEA;EACI,gEAAA;EACA,iDAAA;AACJ","sourcesContent":[".kore-chat-window .botResponseAttachments {\n    color: var(--sdk-chat-window-bot-bubble-font-clr);\n    padding: 2px 5px;\n    width: 100%;\n    margin: 2px 0;\n}\n\n.kore-chat-window .botResponseAttachments .uploadedFileIcon {\n    float: left;\n    width: 100%;\n    margin-top: 3px;\n    border-bottom: 2px solid #F1F0F0;\n}\n\n.kore-chat-window .botuploadedFileName {\n    float: left;\n    width: 100%;\n    text-align: center;\n    min-width: 80px;\n    font-size: 14px;\n    padding: 3px 0px 3px 0px;\n}\n\n.kore-chat-window .uploadedFileName {\n    border-top: 1px solid var(--sdk-chat-widow-primary-border-color);\n    color: var(--sdk-chat-window-bot-bubble-font-clr);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
